<div class="px-3">
  <div class="rem-text-default mb-4">
    <div class="flex align-items-end">
      <div class="rem-bg-light px-3 py-3 mr-2">
        <i class="pi pi-exclamation-circle font-medium text-xl"></i>
      </div>
      <div>
        <div class="text-2xl font-medium">SMS & Email Errors</div>
        <div class="text-right mt-2">View and analyze charts of sms & email errors</div>
      </div>
    </div>
  </div>

  <p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel header="SMS Errors"></p-tabPanel>
    <p-tabPanel header="Email Errors"></p-tabPanel>    
  </p-tabView>

  <div [ngClass]="{'visibility-hidden': activeIndex !== 0}"> 
    <sms-errors />
  </div>      

  <div [ngClass]="{'visibility-hidden': activeIndex !== 1}" > 
    <email-errors />
  </div>
 
</div>